export default __webpack_public_path__ + "static/media/maintainIcon.7b0d0a18.svg";